export default __webpack_public_path__ + "static/time-and-material-d45741d9e93c012105f879f7780ae792.webp";